
import { Helmet } from 'react-helmet';

export function Analytics({ title }) {

  return (
    <div>
      <Helmet>
        <title>LAUNDRY PACK Now | {title}</title>
      </Helmet>
      { process.env.REACT_APP_IS_DEV !== "true" && (
        <Helmet>
          <script async　src='https://www.googletagmanager.com/gtag/js?id=G-L6YF556NWB'></script>
          <script>
            {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){window.dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-L6YF556NWB');
          `}
          </script>
          {/* Meta Pixel Code */}
          <script>
            {`
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '324595360154067');
            fbq('track', 'PageView');
          `}
          </script>
          {/* End Meta Pixel Code */}

          {/* LINE Tag Base Code */}
          {/* Do Not Modify */}
          <script>
            {`
          (function(g,d,o){
            g._ltq=g._ltq||[];g._lt=g._lt||function(){g._ltq.push(arguments)};
            var h=location.protocol==='https:'?'https://d.line-scdn.net':'http://d.line-cdn.net';
            var s=d.createElement('script');s.async=1;
            s.src=o||h+'/n/line_tag/public/release/v1/lt.js';
            var t=d.getElementsByTagName('script')[0];t.parentNode.insertBefore(s,t);
          })(window, document);
          _lt('init', {
            customerType: 'lap',
            tagId: '17f94314-1ee7-40fb-99a4-26eb41933eb5'
          });
          _lt('send', 'pv', ['17f94314-1ee7-40fb-99a4-26eb41933eb5']);
        `}
          </script>
          {/* End LINE Tag Base Code */}
        </Helmet>
      )}
    </div>
  );
}

// 自前D1(app_events)へも同じイベントを送る（GA/Pixelと並行）。画面遷移ファネル等の自前分析用。
// セッションIDはlocalStorageで端末ごとに保持。失敗してもアプリ動作を妨げない。
function lpSessionId() {
  try {
    let s = localStorage.getItem('lp_sid');
    if (!s) { s = Math.random().toString(36).slice(2) + Date.now().toString(36); localStorage.setItem('lp_sid', s); }
    return s;
  } catch (e) { return null; }
}
// 表示環境の判定（行動ログに自動付与）。
//   dm: 'standalone'=ホーム画面に追加したPWAとして起動 / 'browser'=通常ブラウザ
//   inapp: 'line' 等=アプリ内ブラウザ（ポップアップ/3DS別窓が動かない環境）/ ''=通常
export function browserEnv() {
  let dm = 'browser';
  try {
    if ((window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) || window.navigator.standalone === true) dm = 'standalone';
  } catch (e) { /* noop */ }
  const ua = (navigator.userAgent || '');
  let inapp = '';
  if (/ Line\/|LIFF/i.test(ua)) inapp = 'line';
  else if (/Instagram/i.test(ua)) inapp = 'instagram';
  else if (/FBAN|FBAV|FB_IAB/i.test(ua)) inapp = 'facebook';
  else if (/Twitter/i.test(ua)) inapp = 'x';
  else if (/MicroMessenger/i.test(ua)) inapp = 'wechat';
  else if (/; wv\)|Version\/[\d.]+ Chrome\/[\d.]+ Mobile/.test(ua) && /Android/.test(ua) && !/Chrome\/[\d.]+ Mobile Safari/.test(ua)) inapp = 'android-webview';
  return { dm, inapp };
}
export function isInAppBrowser() { return browserEnv().inapp !== ''; }

// ログイン済みなら顧客ID（customerAtom が localStorage 'customer' に保存しているJSONのid）。
// app_events.customer_id に入れて、セッション(端末)ではなく顧客単位でファネルを追えるようにする（2026-09-03）。
function lpCustomerId() {
  try {
    const raw = localStorage.getItem('customer');
    if (!raw) return 0;
    const id = Number(JSON.parse(raw)?.id);
    return Number.isFinite(id) && id > 0 ? id : 0;
  } catch (e) { return 0; }
}

// ?qa=1 を一度踏んだ端末は、以降のイベントを「動作確認」として記録し分析から外す（?qa=0 で解除）。
// トップやLPは1日数件しかないため、デプロイ直後の確認アクセスが混ざると率が大きく動いてしまう。
function isQa() {
  try {
    const q = new URLSearchParams(window.location.search);
    if (q.get('qa') === '1') localStorage.setItem('qa', '1');
    if (q.get('qa') === '0') localStorage.removeItem('qa');
    return localStorage.getItem('qa') === '1';
  } catch (e) { return false; }
}

export function logEvent(event, data = {}) {
  if (process.env.REACT_APP_IS_DEV === 'true') return;
  try {
    const base = 'https://api.laundrypack.app';
    // 表示環境（PWA/アプリ内ブラウザ）を毎イベントに付与（管理画面の環境別集計・トラブル切り分け用）
    const env = browserEnv();
    const merged = { ...(data || {}), _dm: env.dm, _inapp: env.inapp };
    const payload = JSON.stringify({ event, data: merged, session_id: lpSessionId(), customer_id: lpCustomerId(), qa: isQa() });
    // クロスオリジン(now→api)では sendBeacon/fetch とも Content-Type を CORS安全リスト(text/plain)にする。
    // application/json だとプリフライトが必要になりビーコンが送信されず欠測する（サーバーは本文をJSONとして解釈する）。
    navigator.sendBeacon
      ? navigator.sendBeacon(base + '/api/track', new Blob([payload], { type: 'text/plain;charset=UTF-8' }))
      : fetch(base + '/api/track', { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: payload, keepalive: true }).catch(() => {});
  } catch (e) { /* no-op */ }
}

export function Gtag( event,data = {} ) {
  logEvent(event, data);
  if (process.env.REACT_APP_IS_DEV !== 'true') {
    const waitForGtag = setInterval(() => {
      if (window.gtag) {
        // console.log("Gtag is ready, sending event");
        if (data.length === undefined) {
          // console.log(event);
          window.gtag('event', event);
        }else{
          window.gtag('event', event, data);
        }
        clearInterval(waitForGtag);
      } else {
        // console.log("Waiting for gtag...");
      }
    }, 200); // 200msごとにチェック

    return () => clearInterval(waitForGtag); // クリーンアップ
  }
  return null;
}

export function FacebookPixel(event, data = {}) {
  if (process.env.REACT_APP_IS_DEV !== 'true') {
    if (typeof fbq !== 'undefined') {
      const script = document.createElement('script');
      // console.log(data.length);
      if(data.length === undefined){
        script.innerHTML = `
        fbq('track', '`+ event + `');
        `;
      }else{
        script.innerHTML = `
        fbq('track', '`+ event + `', ` + JSON.stringify(data) + `);
        `;
      }
      document.body.appendChild(script);
    }
  }
  return null;
}

export function Linetag( event ) {
  if (process.env.REACT_APP_IS_DEV !== 'true') {
    if (typeof _lt !== 'undefined') {
      const script = document.createElement('script');
      script.innerHTML = `
          _lt('send', 'cv', {
            type: '` + event + `'
          },['17f94314-1ee7-40fb-99a4-26eb41933eb5']);
        `;
      document.body.appendChild(script);
    }
  }
  return null;
}
